import dynamic from 'next/dynamic';
import { SummaryOfChargesProps } from './SummaryOfCharges.types';
import { SummaryOfChargesV2Props } from './V2/index.types';
import { SessionDataMap } from './SummaryOfChargesACRS/SummaryOfCharges.schema';
import { getWindowSession, transformResponse } from '../../utils/helper';

const sessionObject = getWindowSession();
const { crsSystem } = transformResponse(sessionObject, SessionDataMap);
const isACRS = crsSystem === 'ACRS';

export const SummaryOfChargesMGP = dynamic<SummaryOfChargesProps>(() =>
  isACRS ? import('./SummaryOfChargesACRS').then(module => module.SummaryOfChargesMGP) : import('./SummaryOfCharges')
);

export const SummaryOfChargesV2MGP = dynamic<SummaryOfChargesV2Props>(() =>
  import('./V2').then(module => module.SummaryOfChargesV2)
);
